import { render, staticRenderFns } from "./HistoryTalking.vue?vue&type=template&id=2439af01&scoped=true&"
import script from "./HistoryTalking.vue?vue&type=script&lang=js&"
export * from "./HistoryTalking.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTalking.vue?vue&type=style&index=0&id=2439af01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439af01",
  null
  
)

export default component.exports